import React from "react"
import PropTypes from "prop-types"
import styles from "./styles.css"

const EmptyOverlay = ({ children, inPlan, filler }) => (
  <div className={inPlan ? styles.EmptyOverlayWithPlan : styles.EmptyOverlay}>
    {children}
    {filler}
  </div>
)

EmptyOverlay.propTypes = {
  children: PropTypes.node.isRequired,
  inPlan: PropTypes.bool.isRequired,
  filler: PropTypes.node,
}

EmptyOverlay.defaultProps = {
  filler: null,
}

export default EmptyOverlay
